export const LOG_TYPES = {
  LOGIN: 'login',
  RESTRICT: 'restrict',
};
